<template>
  <div class="sp-template">
    <div class="h-title">箱面单管理</div>
    <el-card class="box-card">
      <el-row>
        <el-col :span="12">
          <el-form :model="form" size="small" enctype="multipart/form-data" id="myform" >
            <el-form-item label="订单号前缀" :label-width="formLabelWidth">
              <el-input v-model.lazy="form.orderPrefix" name="orderPrefix" placeholder="不超过4位的字母"></el-input>
            </el-form-item>
            <el-form-item label="LOGO" :label-width="formLabelWidth">
              <el-upload action="#" name="upload" :limit="1" list-type="picture-card" accept=".jpg,.png,.jpeg" 
              :on-change="handlePictureCardChange" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :auto-upload="false"
              :file-list="fileList">

              <i class="el-icon-plus"></i>
            </el-upload>

              <div></div>
              <small>图片高度不超过24px</small>
            </el-form-item>
            <el-form-item :label-width="formLabelWidth">
                <el-input v-model="showLogoUrl" name="showLogoUrl" type="hidden" ></el-input>
              <el-button v-if="in_configs(70901)" size="small" type="primary" @click="print()" >试打印</el-button>
              <el-button v-if="in_configs(70902)" size="small" type="primary" @click="save()" style="margin-left:80px;">保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <img class="img" src="/static/img/miandan.png" alt="" width="450px" height="450px" >
        </el-col>
      </el-row>
    </el-card>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { 
          orderPrefix: ""
        },
      formLabelWidth: "100px",
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      fileList: [],
      showLogoUrl: "" //已保存的logo图片地址
    };
  },
  components: {},
  created() {
      this.query();
  },
  computed: {},
  methods: {
    handlePictureCardChange(file, fileList) {
        console.log(file, fileList);
        this.showLogoUrl = "";
        this.fileList.push(file);
    },
    handleRemove(file, fileList) {
        console.log(file, fileList);
        this.showLogoUrl = "";
        this.fileList = [];
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    valid(){
         let _this = this;
        var reg = /^[a-zA-Z]+$/;
        if(this.form.orderPrefix==null || this.form.orderPrefix=='' || !reg.test(this.form.orderPrefix) || this.form.orderPrefix.length>4){
            this.$message.error('订单号前缀必须为4位以内的字母');
            return false;
        }
        if(this.fileList==null || this.fileList.length==0){
            this.$message.error('请上传图片');
            return false;
        }
        return true;
    },
    print(){        
       if(!this.valid()){
           return;
       }        
        var f = document.getElementById("myform");
        f.setAttribute("action", '/carton-label/print');
        f.setAttribute("method", "post");
        f.submit();
    },
    save(){
        if(!this.valid()){
           return;
       }
        var formData = new FormData();
        this.fileList.forEach((pic, index) => {
            formData.append(pic.uid, pic.raw);
        });
        formData.append("orderPrefix", this.form.orderPrefix);

        this.$request1({
            url: '/carton-label-config',
            method: 'post',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    query(){
        this.$request1({
            url: '/carton-label-config',
            method: 'get',
            withCredentials: true
        })
        .then(response => {                            
            if(response.data.success){
                let data = response.data.data;
                this.form.orderPrefix = data.prefix;
                this.fileList = [{ name: 'logo', url: data.logo}];
                this.showLogoUrl = data.logo;
            }            
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
small{
  color: #888;
}
.img{
  border: 1px solid #ddd;
}
</style>


// WEBPACK FOOTER //
// src/views/system/singlecarton.vue